import * as React from 'react';

const ArrowLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M4.00002 12H20" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
        <path
            d="M8.99966 17C8.99966 17 3.99976 13.3176 3.99976 12C3.99976 10.6824 8.99976 7 8.99976 7"
            stroke={props.color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
        />
    </svg>
);
export default ArrowLeftIcon;
